module.exports = __webpack_public_path__ + "static/arrow-up-disabled.13ffac9f288d65b858b4018ea18ad565.svg";